import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ElementLibrarySelector from '@/components/DesignStudio/ElementLibrarySelector.vue';
import type { CanvasEx } from '@/typings/canvas';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { ColorObject } from '@/typings/libraries';
import { LibraryTypeEnum } from '@/utils/enums/libraryType.enum';
import { colorsListStore, useColorOptions } from '@/composables/colorOptions';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageColorProperties',
  props: {
    canvas: null,
    imageElement: null,
    editMode: { type: Boolean },
    cmykMode: { type: Boolean }
  },
  emits: ["open-color-library-selector"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'open-color-library-selector'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    canvas: CanvasEx;
    imageElement: ImagePlaceholderElement;
    editMode?: boolean;
    cmykMode?: boolean;
};

const COLOR_TYPE = LibraryTypeEnum.Color;





const disabled = computed(() => !!props.imageElement?.locked);

// Option 1 when the requested one is gone, and the single `color` of images saved before they had options
const fallbackColor = (element: ImagePlaceholderElement): ColorObject | undefined => {
    const firstColor = element.colors?.find((color) => color.position === 1);
    if (firstColor) return firstColor;

    const legacyColor = element.color;
    if (!legacyColor) return undefined;
    return typeof legacyColor === 'string' ? { hex: legacyColor, alpha: 1, cmyk: '' } : legacyColor;
};

const colors = useColorOptions<ImagePlaceholderElement>({
    store: colorsListStore((element, css) => element.set('imageColor', css), fallbackColor),
    element: () => props.imageElement,
    canvas: () => props.canvas,
    editMode: () => props.editMode,
    openLibrarySelector: () => emit('open-color-library-selector')
});

return { __sfc: true,COLOR_TYPE, props, emit, disabled, fallbackColor, colors, ElementLibrarySelector }
}

})